import {AxiosPromise} from 'axios';
import httpClient from 'api/httpClient';

export interface IndividualPayrocMerchantAccount {
    merchantId: string;
    id: number;
}

export interface PayrocMerchantAccountsForBusiness {
    payrocMerchantAccounts: IndividualPayrocMerchantAccount[];
    businessId: number;
}

export const getPayrocMerchantAccounts = (
    businessId: number,
): AxiosPromise<PayrocMerchantAccountsForBusiness> => {
    return httpClient({
        method: 'GET',
        url: `/super-admin/businesses/${businessId}/payroc/merchants`,
    });
};
